import PageBanner from '@/common/components/page-banner';

interface LowerShippingFeesBannerProps {
  isSticky?: boolean;
}

export default function LowerShippingFeesBanner({
  isSticky,
}: LowerShippingFeesBannerProps) {
  const bannerContent = (
    <>
      {/* Mobile */}
      <div className="flex flex-row items-center md:hidden">
        <p className="body3 py-[2px] text-left">
          <span className="body3-strong">Good news!</span> Lower shipping fees, more cars
          to choose from.
        </p>
      </div>

      {/* Desktop */}
      <p className="body3 hidden py-[2px] md:block">
        <span className="body3-strong">Good news!</span> Lower shipping fees, more cars to
        choose from.
      </p>
    </>
  );

  return <PageBanner isSticky={isSticky}>{bannerContent}</PageBanner>;
}
